// extracted by mini-css-extract-plugin
export default {"cls1":"uWXdQpNzKTYgM6OFxwEK","cls2":"kD0J0_5QKnrgZm6jkdCO uWXdQpNzKTYgM6OFxwEK"};